import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/dissatisfied.vue
var s = {
	name: "DtIconDissatisfied",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--dissatisfied"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Dissatisfied",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.5 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM4 4.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Zm3 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5ZM4.237 7.096c.4-.29 1-.596 1.763-.596.763 0 1.364.305 1.763.596a3.474 3.474 0 0 1 .62.582l.01.014.005.005v.002H8.4L8 8l.4-.3a.5.5 0 0 1-.798.602L7.599 8.3a2.474 2.474 0 0 0-.425-.395A1.995 1.995 0 0 0 6 7.5c-.487 0-.886.195-1.175.404a2.474 2.474 0 0 0-.424.395l-.002.003A.5.5 0 0 1 3.6 7.7L4 8l-.4-.3.001-.001.001-.002.004-.005.01-.014c.01-.01.021-.025.036-.042a3.474 3.474 0 0 1 .585-.54Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=dissatisfied.js.map